"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    none: "0",
    quark: "2px",
    nano: "4px",
    xsmall: "6px",
    small: "8px",
    medium: "10px",
    large: "16px",
    xlarge: "20px",
    xxlarge: "24px",
    circle: "9999px"
};
//# sourceMappingURL=radius.js.map